import axiosInstance from "../Axios";
function getTimesheets(pageNo = 1, params) {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }

    if (params.export) {
      return axiosInstance.get("/timesheet", {
        params: queryParams,
        responseType: "blob",
      });
    }

    return axiosInstance.get("/timesheet", { params: queryParams });
  } catch (error) {
    console.log("Error while fetching timesheets:", error);
    throw error;
  }
}

function getShiftTypes() {
  try {
    return axiosInstance.get("/shift-types");
  } catch (error) {
    console.log("error while fetching shift types", error);
    throw error;
  }
}

function getUserProjects() {
  try {
    return axiosInstance.get("/projects");
  } catch (error) {
    console.log("error while fetching project", error);
    throw error;
  }
}

function getUserTakByProject(project_id) {
  try {
    return axiosInstance.get(`/tasks/user-task-list/${project_id}`);
  } catch (error) {
    console.log("error while fetching project", error);
    throw error;
  }
}

function getAllProjects() {
  try {
    return axiosInstance.get("/projects/all");
  } catch (error) {
    console.log("error while fetching project", error);
    throw error;
  }
}

function fetchMyReporteeManagers() {
  try {
    return axiosInstance.get("/users/my-reportee-managers");
  } catch (error) {
    console.log("error while fetching my reportee managers", error);
    throw error;
  }
}

function approveRejectTimesheet(data) {
  try {
    return axiosInstance.patch("/timesheet/approve-reject", data);
  } catch (error) {
    console.log(error, "error while approving or rejecting timesheet");
    throw error;
  }
}

function approveRejectCompoff(data) {
  try {
    return axiosInstance.patch("/timesheet/compoff-approve-reject", data);
  } catch (error) {
    console.log(error, "error while approving or rejecting compoff");
    throw error;
  }
}

function deleteTimesheet(id) {
  try {
    return axiosInstance.delete("/timesheet/delete/" + id);
  } catch (error) {
    console.log(error, "error while deleting timesheet");
    throw error;
  }
}

function submitTimesheet(data) {
  try {
    return axiosInstance.post("/timesheet/add-edit", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    console.log(error, "error while submitting timesheet");
    throw error;
  }
}

function getUserSettings() {
  try {
    return axiosInstance.get("/users/user-settings");
  } catch (error) {
    console.log("Error fetching user settings:", error);
    throw error;
  }
}

function getTimesheetDetails(id) {
  try {
    return axiosInstance.get("/timesheet/details/" + id);
  } catch (error) {
    console.log("Error fetching timesheet details:", error);
    throw error;
  }
}
const downloadTimesheetDocument = async (fileName) => {
  try {
    return await axiosInstance.get("/timesheet/download", {
      params: { fileName: fileName },
      responseType: "blob",
    });
  } catch (error) {
    console.error("Error downloading resignation document:", error);
    throw error;
  }
};

export {
  getTimesheets,
  getShiftTypes,
  getUserProjects,
  getUserTakByProject,
  fetchMyReporteeManagers,
  approveRejectTimesheet,
  approveRejectCompoff,
  deleteTimesheet,
  submitTimesheet,
  getUserSettings,
  getTimesheetDetails,
  downloadTimesheetDocument,
  getAllProjects,
};
